import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TuiDialogContext } from '@taiga-ui/core';
import { injectContext } from '@taiga-ui/polymorpheus';
import { BaseComponent } from '@src/app/modules/base';
import { AlertService } from '@src/core/services';
import { InputItemType } from '@src/app/modules/search-cities';

import { LpUserProfileService } from '../../services';

@Component({
  selector: 'app-city-dialog',
  templateUrl: './city-dialog.component.html',
  styleUrls: ['./city-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CityDialogComponent extends BaseComponent {
  private readonly lpUserProfileService = inject(LpUserProfileService);
  private readonly alertService = inject(AlertService);
  private readonly context = injectContext<TuiDialogContext<void>>();

  selectedCity?: InputItemType;
  loading = false;

  onClickSaveButton() {
    if (!this.selectedCity) return;

    this.loading = true;

    this.lpUserProfileService.updateUserCity(this.selectedCity).subscribe({
      next: () => {
        this.context.completeWith();
      },
      error: err => {
        this.alertService.error(err);
        this.loading = false;
        this.cdr.markForCheck();
      },
    });
  }
}
